import { render, staticRenderFns } from "./PoliciesOverview.vue?vue&type=template&id=22409d7b&scoped=true"
import script from "./PoliciesOverview.vue?vue&type=script&lang=ts"
export * from "./PoliciesOverview.vue?vue&type=script&lang=ts"
import style0 from "./PoliciesOverview.vue?vue&type=style&index=0&id=22409d7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22409d7b",
  null
  
)

export default component.exports